import * as React from 'react'
export function HourGlass({ title, className, ...props }) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.606061 0C0.271341 0 0 0.267499 0 0.597476C0 0.927456 0.271341 1.19495 0.606061 1.19495H1.41401V2.40696C1.41401 4.18681 2.27584 5.85974 3.73364 6.90972L4.35931 7.36036C4.80114 7.67858 4.80114 8.32863 4.35931 8.64685L3.73364 9.09749C2.27584 10.1475 1.41401 11.8204 1.41401 13.6002V14.805H0.606061C0.271341 14.805 0 15.0725 0 15.4025C0 15.7325 0.271341 16 0.606061 16H12.7273C13.062 16 13.3333 15.7325 13.3333 15.4025C13.3333 15.0725 13.062 14.805 12.7273 14.805H11.9191V13.6002C11.9191 11.8204 11.0572 10.1475 9.59944 9.09749L8.97377 8.64685C8.53194 8.32863 8.53194 7.67858 8.97377 7.36036L9.59944 6.90972C11.0572 5.85974 11.9191 4.18681 11.9191 2.40696V1.19495H12.7273C13.062 1.19495 13.3333 0.927456 13.3333 0.597476C13.3333 0.267501 13.062 1.82335e-06 12.7273 1.82335e-06L0.606061 0ZM5.07437 6.39548L4.4487 5.94484C3.30329 5.11987 2.62613 3.80542 2.62613 2.40696V1.2322H10.7069V2.40696C10.7069 3.80542 10.0298 5.11987 8.88438 5.94484L8.25871 6.39548C7.15413 7.19104 7.15413 8.81615 8.25871 9.61172L8.88438 10.0624C10.0298 10.8873 10.7069 12.2018 10.7069 13.6002V14.775H2.62613V13.6002C2.62613 12.2018 3.30327 10.8873 4.4487 10.0624L5.07437 9.61172C6.17895 8.81615 6.17895 7.19104 5.07437 6.39548ZM7.16032 10.0914C6.78429 10.0451 6.40384 10.0451 6.02781 10.0914C4.50471 10.2791 3.36175 11.5555 3.36175 13.0687V14.0048C3.36175 14.2248 3.54263 14.4032 3.76578 14.4032H9.42235C9.6455 14.4032 9.82638 14.2248 9.82638 14.0048V13.0687C9.82638 11.5555 8.68342 10.2791 7.16032 10.0914Z"
        fill="#5C708A"
      />
    </svg>
  )
}
export default HourGlass
